const SF_PKCE_VERIFIER_PREFIX = 'sf_pkce_verifier:';

const getScopedPkceVerifierKey = (state: string) => `${SF_PKCE_VERIFIER_PREFIX}${state}`;

export const savePkceVerifierByState = (state: string, verifier: string) => {
  if (!state || !verifier) {
    return;
  }

  sessionStorage.setItem(getScopedPkceVerifierKey(state), verifier);
};

export const getAndRemovePkceVerifierByState = (state: string): string => {
  if (!state) {
    return '';
  }

  const key = getScopedPkceVerifierKey(state);
  const verifier = sessionStorage.getItem(key) ?? '';

  sessionStorage.removeItem(key);

  return verifier;
};
